import { ICopyable } from '../controls/common/icopyable';
import { CriteriaSearchZone } from './enums/criteria-search-zone';
import { SearchMode } from './enums/search-mode';
import { IAttributeAssignmentLight } from './interfaces/attribute-assignment-light.interface';
import { SearchOptions } from './search-options';
import { SettingsBase } from './settings-base';

export class AttributesAssignmentSettings extends SettingsBase implements ICopyable<AttributesAssignmentSettings> {
    public issuer: string = null;
    public customerId: number = null;
    public documentTypeId: number = null;
    public searchExpression: string = null;
    public searchOptions: SearchOptions = new SearchOptions();
    public criteriaSearchZones: CriteriaSearchZone[] = [];
    public searchMode: SearchMode = SearchMode.None;
    public attributesAssignment: IAttributeAssignmentLight[] = [];

    public createCopy(): AttributesAssignmentSettings {
        const instance = new AttributesAssignmentSettings();
        instance.issuer = this.issuer;
        instance.customerId = this.customerId;
        instance.documentTypeId = this.documentTypeId;
        instance.searchExpression = this.searchExpression;
        instance.searchOptions = this.searchOptions;
        instance.criteriaSearchZones = this.criteriaSearchZones;
        instance.searchMode = this.searchMode;
        instance.attributesAssignment = this.attributesAssignment;
        instance.type = this.type;

        return instance;
    }

    public static createFrom(other: any): AttributesAssignmentSettings {
        const instance = new AttributesAssignmentSettings();
        instance.issuer = other.issuer;
        instance.customerId = other.customerId;
        instance.documentTypeId = other.documentTypeId;
        instance.searchExpression = other.searchExpression;
        instance.searchOptions = other.searchOptions;
        instance.criteriaSearchZones = other.criteriaSearchZones;
        instance.searchMode = other.searchMode;
        instance.attributesAssignment = other.attributesAssignment;
        instance.type = other.type;

        return instance;
    }

    public copyFrom(other: any) {
        this.issuer = other.issuer;
        this.customerId = other.customerId;
        this.documentTypeId = other.documentTypeId;
        this.searchExpression = other.searchExpression;
        this.searchOptions = other.searchOptions;
        this.criteriaSearchZones = other.criteriaSearchZones;
        this.searchMode = other.searchMode;
        this.attributesAssignment = other.attributesAssignment;
        this.type = other.type;
    }
}
